// Filter persistence for E-mails enviados (/items-enviados/emails[/erros]).
//
// Both routes share one screen (the component stays mounted when the route
// changes), so they share one storage key. The URL always wins for the
// "failed" status: on /erros the status is 'failed' regardless of what was
// saved, and 'failed' itself is never saved — the route carries it.

export var EMAILS_LOGS_FILTERS_KEY = 'emailsLogs';
export var EMAILS_LOGS_PATH = '/items-enviados/emails';
export var EMAILS_LOGS_FAILED_PATH = '/items-enviados/emails/erros';

export var getDefaultEmailsLogsFilters = function() {
  return {
    search: '',
    status: null,
  };
};

export var isFailedRoute = function(pathname) {
  return (pathname || '').indexOf('erros') !== -1;
};

export var getEffectiveStatus = function(filters, pathname) {
  if (isFailedRoute(pathname)) return 'failed';
  return filters.status || null;
};

// Clicking a status (card or popover): returns the status to save and the
// route to go to. Clicking the active status clears it.
export var getStatusSelection = function(currentStatus, clickedStatus) {
  if (currentStatus === clickedStatus) {
    return { status: null, path: EMAILS_LOGS_PATH };
  }
  if (clickedStatus === 'failed') {
    return { status: null, path: EMAILS_LOGS_FAILED_PATH };
  }
  return { status: clickedStatus, path: EMAILS_LOGS_PATH };
};

// Badge: only what differs from the defaults (the /erros route counts as the
// "failed" status filter).
export var countActiveEmailsLogsFilters = function(filters, pathname) {
  return (getEffectiveStatus(filters, pathname) ? 1 : 0) + (filters.search ? 1 : 0);
};
